import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import RequireDemoAuth from './components/RequireDemoAuth';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import ToolboxPage from './pages/ToolboxPage';
import JobsPage from './pages/JobsPage';
import DashboardPage from './pages/DashboardPage';
import SchedulesPage from './pages/SchedulesPage';
import { isDemoAuthenticated } from './utils/demoAuth';

function LoginRedirect() {
  if (isDemoAuthenticated()) {
    return <Navigate to="/toolbox" replace />;
  }
  return <LoginPage />;
}

function Guard({ children }) {
  return <RequireDemoAuth>{children}</RequireDemoAuth>;
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginRedirect />} />
          <Route path="/toolbox" element={<Guard><ToolboxPage /></Guard>} />
          <Route path="/jobs" element={<Guard><JobsPage /></Guard>} />
          <Route path="/dashboard" element={<Guard><DashboardPage /></Guard>} />
          <Route path="/schedules" element={<Guard><SchedulesPage /></Guard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
